import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Affix from '../../wui-affix/src';
import { createChainedFunction } from '../../wui-core/src';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  getContainer: PropTypes.func,
  // 指定滚动的容器
  affix: PropTypes.bool,
  // 固定模式
  offsetTop: PropTypes.number,
  // 距离窗口顶部达到指定偏移量后触发
  showInkInFixed: PropTypes.bool,
  // affix={false} 时是否显示小圆点
  onChange: PropTypes.func,
  // 监听锚点链接改变
  onClick: PropTypes.func // click 事件的回调

};
var defaultProps = {
  getContainer: function getContainer() {
    return window;
  },
  prefixCls: 'wui-anchor',
  affix: true,
  offsetTop: 0,
  showInkInFixed: false,
  onChange: null,
  onClick: null
};
var AntdAnchor = (_dec = WebUI({
  name: "anchor",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AntdAnchor, _Component);

  var _super = _createSuper(AntdAnchor);

  function AntdAnchor(props) {
    var _this;

    _classCallCheck(this, AntdAnchor);

    _this = _super.call(this, props);
    _this.state = {
      activeKey: ''
    }; // this.wrapperRef = React.createRef();

    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AntdAnchor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var children = this.props.children;
      React.Children.map(children, function (child, index) {
        if (index === 0) {
          _this2.setState({
            activeKey: child.props.href
          });
        }
      });
    } // componentDidUpdate () {
    //     this.updateInk();
    // }
    // updateInk = () => {
    //     const { prefixCls, wrapperRef } = this;
    //     const anchorNode = wrapperRef.current;
    //     const linkNode = anchorNode?.getElementsByClassName(`${prefixCls}-link-title-active`)[0];
    //     if (linkNode) {
    //       this.inkNode.style.top = `${(linkNode).offsetTop + linkNode.clientHeight / 2 - 4.5}px`;
    //     }
    // };
    // saveInkNode = (node) => {
    //     this.inkNode = node;
    // };
    // onscrollTo = () => {
    //     const { prefixCls, wrapperRef } = this;
    //     const anchorNode = wrapperRef.current;
    //     const linkNode = anchorNode?.getElementsByClassName(`${prefixCls}-link-title-active`)[0];
    //     if (linkNode) {
    //       this.inkNode.style.top = `${(linkNode).offsetTop + linkNode.clientHeight / 2 - 4.5}px`;
    //     }
    // }

  }, {
    key: "handleSelect",
    value: function handleSelect(val, e) {
      this.setState({
        activeKey: val.href
      }); // let { title, href } = val

      if (this.props.onClick) {
        this.props.onClick(val);
      }

      if (this.props.onChange) {
        this.props.onChange(val.href);
      } // const { prefixCls, wrapperRef } = this;
      // const anchorNode = wrapperRef.current;
      // const linkNode = document.getElementsByClassName(`${prefixCls}-link-title-active`)[0];
      // if (linkNode) {
      //     this.inkNode.style.top = `${(linkNode).offsetTop + linkNode.clientHeight / 2 - 4.5}px`;
      //   }

    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          style = _this$props.style,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          prefixCls = _this$props.prefixCls,
          affix = _this$props.affix,
          offsetTop = _this$props.offsetTop,
          getContainer = _this$props.getContainer,
          showInkInFixed = _this$props.showInkInFixed;
      var activeKey = this.state.activeKey;
      var wrapperClass = classNames("".concat(prefixCls, "-wrapper"), className);

      var wrapperStyle = _objectSpread({
        maxHeight: offsetTop ? "calc(100vh - ".concat(offsetTop, "px)") : '100vh'
      }, style);

      var anchorClass = classNames(prefixCls, {
        fixed: !affix && !showInkInFixed
      }); // const inkClass = classNames(`${prefixCls}-ink-ball`, {
      //     visible: '',
      // });

      var anchorContent = /*#__PURE__*/React.createElement("div", {
        ref: this.wrapperRef,
        className: wrapperClass,
        style: wrapperStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: anchorClass
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-ink")
      }), React.Children.map(children, function (child) {
        var linkHref = child.props.href;
        var childProps = {
          onscrollTo: _this3.onscrollTo,
          eventKey: linkHref,
          expanded: linkHref === activeKey,
          onSelect: createChainedFunction(_this3.handleSelect, child.props.onSelect)
        };
        return /*#__PURE__*/React.cloneElement(child, childProps);
      })));
      return /*#__PURE__*/React.createElement("div", null, !affix ? anchorContent : /*#__PURE__*/React.createElement(Affix, {
        offsetTop: offsetTop,
        target: getContainer
      }, anchorContent));
    }
  }]);

  return AntdAnchor;
}(Component)) || _class);
AntdAnchor.propTypes = propTypes;
export default AntdAnchor;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-anchor/src/AntdAnchor.js